import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { createFragmentRegistry } from "@apollo/client/cache";
import { NetworkError } from "@apollo/client/errors";
import { ApolloLink } from "@apollo/client/link/core";
import { onError } from "@apollo/client/link/error";
import { Emitter } from "react-event-hook";

import { withApolloRetryLink } from "src/authentication/withApolloRetryLink.ts";
import { withAuthMiddleware } from "src/authentication/withAuthMiddleware.ts";
import { withXCSRFToken } from "src/authentication/withXCSRFToken.ts";
import { Message } from "src/hooks/useEvents.ts";

import fragmentTypes from "./fragment-types.json";

const onErrorInterceptor = (emitError: Emitter<Message>) => {
  return onError(({ networkError }) => {
    const error = networkError as NetworkError & { statusCode: number };
    if (/5[0-9][0-9]/.test(error?.statusCode?.toString() ?? ""))
      emitError({ code: error?.statusCode?.toString() ?? "", message: error?.message });
  });
};

export const createApolloClient = (emitError) => {
  return new ApolloClient({
    link: ApolloLink.from([
      withApolloRetryLink(),
      withAuthMiddleware(),
      withXCSRFToken(),
      onErrorInterceptor(emitError),
      createHttpLink({ uri: "/v1/graphql" }),
    ]),
    cache: new InMemoryCache({
      possibleTypes: fragmentTypes,
      fragments: createFragmentRegistry(),
    }),
  });
};
